import { Moment } from "moment";
import { AppThunk, AppDispatch } from "../../types";
import fetchReport from "../../../shared/fetchReport";

type FetchUnfulfilledDirectoryOver20HoursProps = { startDate: Moment; endDate: Moment };

export type FetchUnfulfilledDirectoryOver20Hours = (
  dates: FetchUnfulfilledDirectoryOver20HoursProps,
) => void;

const fetchUnfulfilledDirectoryOver20Hours = ({
  startDate,
  endDate,
}: FetchUnfulfilledDirectoryOver20HoursProps): AppThunk => async (dispatch: AppDispatch) => {
  const params = {
    start_date: startDate.format("YYYY-MM-DD"),
    end_date: endDate.format("YYYY-MM-DD"),
  };
  await fetchReport("unfulfilled_directory_over_20_hours", dispatch, params);
};

export default fetchUnfulfilledDirectoryOver20Hours;
